<template>
  <div class="contract-attachment" style="min-height: 400px">
    <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%" row-key="id">
      <el-table-column prop="rfileName" label="文件名称" align="left" show-overflow-tooltip>
        <template v-slot="{row}">
          <el-button type="text" class="show-one-line" @click="openContract(row.rFileCode)">
            {{ row.rFileName }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="rUpdatedBy" label="上传人" align="left" show-overflow-tooltip />
      <el-table-column prop="rCreatedTime" label="上传时间" align="left" />
      <el-table-column prop="rUpdatedTime" label="最后更新时间" align="left" />
      <el-table-column prop="pname" label="操作" align="left" fixed="right" width="80">
        <template v-slot="{row}">
          <el-button type="text" @click="downOneFile(row.rFileCode)">
            下载
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
import { getReturnsContractAttachment, attachmentGetToken, getUrlByFileID } from '@/API/index';
export default {
  name: 'ContractAttachment',
  props: {
    contractId: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      tableData: [],
      tableLoading: false,
      token: '',
      uploadUrl: '',
      downFileUrl: '',
      fileserveDownUrl: ''
    };
  },
  methods: {
    searchFiles () {
      this.tableLoading = true;
      getReturnsContractAttachment(this.contractId, 1).then((res) => {
        let json = res.data;
        this.tableLoading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.token = json.data.token;
          this.uploadUrl = json.data.uploadUrl;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch(() => {

      });
    },
    // 查看合同附件详情
    openContract (fileToken) {
      getUrlByFileID(fileToken).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          window.open(json.data);
        }
      }).catch((res) => {

      });
    },
    // 下载合同附件
    downOneFile (id) {
      this.fileserveDownUrl = this.downFileUrl + `/${id}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    }
  },
  mounted () {
    this.searchFiles();
    this.initToken();
  }
};
</script>

<style lang="scss" scoped>
.show-one-line{
  width: 100%;
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
</style>
